import React from "react";
import PreferencesComponent from "../../pages/Preferences/Preferences";

const PreferencesContainer: React.FC<any> = props => {
  return <PreferencesComponent {...props} />;
};
export default PreferencesContainer;
